'use client'

import { SignInButton, SignedIn, SignedOut, Waitlist } from '@clerk/nextjs'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/navigation'
import { useAuth } from '@clerk/nextjs'

export default function HomePage() {
  const router = useRouter()
  const { isLoaded, userId } = useAuth()
  const [showWaitlist, setShowWaitlist] = useState(false)

  // 클라이언트 사이드 리다이렉트 (fallback)
  useEffect(() => {
    if (isLoaded && userId) {
      router.push('/dashboard')
    }
  }, [isLoaded, userId, router])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-24">
      <SignedIn>
        {/* middleware에서 리다이렉트 처리 */}
        <div className="text-gray-600">리디렉션 중...</div>
      </SignedIn>

      <SignedOut>
        {/* 로그인 안 된 경우 로그인 버튼 표시 */}
        <div className="flex flex-col items-center gap-4">
          <h1 className="text-4xl font-bold mb-8">AI Avatar Builder</h1>
          <p className="text-gray-600 mb-8">AI 에이전트를 만들고 관리하세요</p>

          {showWaitlist ? (
            <div className="w-full max-w-md">
              <Waitlist />
              <button
                onClick={() => setShowWaitlist(false)}
                className="mt-4 text-sm text-gray-500 hover:text-gray-700"
              >
                ← 돌아가기
              </button>
            </div>
          ) : (
            <div className="flex gap-4">
              <SignInButton mode="modal">
                <button className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
                  로그인
                </button>
              </SignInButton>
              <button
                onClick={() => setShowWaitlist(true)}
                className="px-6 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
              >
                가입 신청
              </button>
            </div>
          )}
        </div>
      </SignedOut>
    </div>
  )
}